import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { FileUploader } from "../../Common/FileUploader";
import { Flows } from "../../Flows/Flows";
export class PartCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Part"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <FileUploader
                      fileType="IMAGE"
                      label="Upload Image"
                      accept="image/*"
                      currentFiles={this.props.editedObject.imageUrls}
                      updateFiles={this.props.updateValue}
                      limited={true}
                      field={"imageUrls"}
                    />
                  </div>
                </div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Type</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.operationalType || ""}
                        disabled={true}
                        options={this.props.operationalTypeOptions}
                        onChange={e => {
                          this.props.updateValue("operationalType", e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Attribute Set *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.attributeSetId || ""}
                        options={this.props.attributeSetMap}
                        disabled={this.props.crudlState === CrudlStatus.UPDATE}
                        onChange={e => {
                          this.props.updateValue("attributeSetId", e.value);
                          this.props.selectAttributeSet(e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  {this.props.editedObject.attributeSetId && (
                    <React.Fragment>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">Name *</label>
                        </div>

                        <div className="ui-g-9">
                          <pr.InputText
                            required={true}
                            value={this.props.editedObject.name}
                            onChange={e =>
                              this.props.updateValue("name", e.target.value)
                            }
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">Description *</label>
                        </div>

                        <div className="ui-g-9">
                          <pr.InputText
                            required={true}
                            value={this.props.editedObject.shortDescription}
                            onChange={e =>
                              this.props.updateValue(
                                "shortDescription",
                                e.target.value
                              )
                            }
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">
                            Long Description
                          </label>
                        </div>

                        <div className="ui-g-9">
                          <textarea
                            id={
                              this.props.editedObject.longDescription +
                              " Details"
                            }
                            rows={5}
                            placeholder=""
                            value={this.props.editedObject.longDescription}
                            onChange={e => {
                              this.props.updateValue(
                                "longDescription",
                                e.target.value
                              );
                            }}
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                            style={{
                              width: "100%",
                              backgroundColor: "transparent"
                            }}
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">SKU *</label>
                        </div>

                        <div className="ui-g-9">
                          <pr.InputText
                            required={true}
                            value={this.props.editedObject.sku}
                            onChange={e =>
                              this.props.updateValue("sku", e.target.value)
                            }
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>

                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  {this.props.editedObject.attributeSetId && (
                    <pr.TabView onTabChange={e => {}}>
                      <pr.TabPanel header="Details">
                        <React.Fragment>
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Stock Type</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.Dropdown
                                value={this.props.editedObject.stockType || ""}
                                options={this.props.stockTypeOptions}
                                onChange={e => {
                                  this.props.updateValue("stockType", e.value);
                                }}
                                filter={true}
                                filterBy="label"
                                filterPlaceholder="Search"
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                          {this.props.editedObject.stockType ===
                            "PURCHASED" && (
                            <div className="ui-g-12">
                              <div className="ui-g-3">
                                <label className="input-label">Supplier</label>
                              </div>

                              <div className="ui-g-9">
                                <pr.Dropdown
                                  value={
                                    this.props.editedObject.supplierId || ""
                                  }
                                  options={this.props.supplierMap}
                                  onChange={e => {
                                    this.props.updateValue(
                                      "supplierId",
                                      e.value
                                    );
                                  }}
                                  filter={true}
                                  filterBy="label"
                                  filterPlaceholder="Search"
                                  style={{ width: "100%" }}
                                />
                              </div>
                            </div>
                          )}
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Price</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.InputText
                                keyfilter={"money"}
                                value={this.props.editedObject.price}
                                onChange={e =>
                                  this.props.updateValue(
                                    "price",
                                    e.target.value
                                  )
                                }
                                disabled={
                                  this.props.crudlState === CrudlStatus.VIEW
                                }
                              />
                            </div>
                          </div>
                          <div className="ui-g-12">
                            <div className="ui-g-3">
                              <label className="input-label">Cost</label>
                            </div>

                            <div className="ui-g-9">
                              <pr.InputText
                                keyfilter={"money"}
                                value={this.props.editedObject.cost}
                                onChange={e =>
                                  this.props.updateValue("cost", e.target.value)
                                }
                                disabled={
                                  this.props.crudlState === CrudlStatus.VIEW
                                }
                              />
                            </div>
                          </div>

                          {this.attributeListToFields()}
                        </React.Fragment>
                      </pr.TabPanel>
                      <pr.TabPanel header="Operations and Routings Details">
                        <Flows
                          type={"PART"}
                          crudlState={this.props.crudlState}
                          typeDisplay="parts"
                          componentList={
                            this.props.editedObject.selectedComponents
                          }
                          id={this.props.editedObject.id}
                          stationMap={this.props.stationMap}
                          currentFlowBean={this.props.editedObject.flowRequest}
                          updateValue={this.props.updateValue}
                        />
                      </pr.TabPanel>
                    </pr.TabView>
                  )}
                </div>
                {/* <div className="ui-g-1"></div> */}
                {/*        
    
                <div className="ui-g-5"></div> */}
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
  attributeListToFields = () => {
    let componentArray = [];
    let i = 0;
    console.log(this.props.selectedAttributeSet);
    if (this.props.selectedAttributeSet !== undefined) {
      if (this.props.selectedAttributeSet.attributeBeanList !== undefined) {
        this.props.selectedAttributeSet.attributeBeanList.forEach(e => {
          if (e.type === "LIST") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.Dropdown
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    options={pr.getDropdownOptionsFromList(e.acceptedValues)}
                    onChange={f => {
                      this.props.updateAttributeProperties(e.name, f.value);
                    }}
                    filter={true}
                    filterBy="label"
                    filterPlaceholder="Search"
                    style={{ width: "100%" }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                
                  {this.props.editedObject.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {this.props.editedObject.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          if (e.type === "INPUT") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.InputText
                    id={e.name + " Attribute"}
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    onChange={f => {
                      this.props.updateAttributeProperties(
                        e.name,
                        f.target.value
                      );
                    }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                  <b>{e.unitOfMeasurement || ""}</b>
                </div> */}
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
        
                  {s.editedPart.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {s.editedPart.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>

                      {this.state.attributeVariable[e.name] && (
                        <div className="ui-g-12">
                          {this.getAcceptedValues(e.name)}
                        </div>
                      )}
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          i++;
        });
      }
    }

    return componentArray;
  };
}



// WEBPACK FOOTER //
// ./src/components/Part/UI/PartCard.js